module.exports = __webpack_public_path__ + "static/img/academy_edu_learn_1.523654eb.png";